import { Breadcrumb, Button, Col, Form, Image, Input, Row, Steps } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./daValid.scss";
import { Content } from "antd/es/layout/layout";
import DALayout from "../da-layout";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useState } from "react";
import DAValidList from "./ldaValidList";
import Loading from "../../../auxiliary/loader/loading";
import { validateInput } from "../../../../tools/tools";
const DAValid = () => {
  const [t] = useTranslation("global");
  const { querySPPurchaseByMethodOfReceipt, querySPPurchaseByMethodOfReceiptList, querySPPurchaseVProfileDealerById } = useDealer();
  const { getDocument } = useAPIPublic();
  const [changeList, setChangeList] = useState([]);
  const [purchase, setPurchase] = useState({});
  const [docFile, setDocFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [msisdn, setMsisdn] = useState(0);
  const handleSubmit = async (value) => {
    setIsLoading(true);
    let payload = {
      certtype: 0,
      certno: value?.certno,
      methodofreceipt: [3, 5],
    };
    // let response = await querySPPurchaseByMethodOfReceipt(payload);
    let response = await querySPPurchaseByMethodOfReceiptList(payload);

    if (response) {
      setChangeList(response);
      if (response.length > 0) {
        let resPurchase = await querySPPurchaseVProfileDealerById(response[0].guD_PurchaseProductId);
        if (resPurchase) {
          setPurchase(resPurchase);
          let resDoc = await getDocument(resPurchase.gudfK_CertNoDocumentId);
          setDocFile(resDoc);
        }
      }
    }
    setIsLoading(false);
  };
  return (
    <DALayout>
      <div className="holder-top-of-page-content">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("deliveryArea.title") }]}
          />
          <div className="title-page">
            <h3>{t("deliveryArea.title")}</h3>
            <p></p>
          </div>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main da-container">
          <div className="g-format-page">
            <div className="g-body-format-page">
              <div className="g-format-steps">
                <div className="holder-step">
                  <Steps
                    size="small"
                    className="step-wizard"
                    current={0}
                    responsive
                    items={[
                      {
                        title: "احراز هویت",
                      },
                      {
                        title: "شماره کیت جدید",
                      },
                      {
                        title: "سند",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="da-valid-container">
                <Form layout="vertical" onFinish={handleSubmit}>
                  <Row gutter={16}>
                    <Col xl={6} lg={8} md={10} sm={24} xs={24}>
                      <Form.Item
                        name="certno"
                        className="input-normal"
                        label="کدملی"
                        rules={[validateInput({ validate: true, t: t, type: "number", length: 10 })]}
                      >
                        <Input autoComplete="off" dir="ltr" placeholder="کد ملی" maxLength={10} />
                      </Form.Item>
                    </Col>
                    <Col style={{ margin: "auto 0" }}>
                      <Button htmlType="submit" className="btn-normal btn-green">
                        جستجو
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
              {changeList?.length > 0 && (
                <>
                  <div className="holder-show-result g-layout-report">
                    <DAValidList list={changeList} purchase={purchase} />
                  </div>
                  <div className="holder-show-image">
                    <Image width={300} src={docFile} />
                  </div>
                </>
              )}
            </div>
          </div>
        </Content>
      </div>
      <Loading isOpen={isLoading} />
    </DALayout>
  );
};

export default DAValid;
